"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = require("owa-session-store");
var getTheme_1 = require("owa-theme/lib/utils/getTheme");
var normalizeThemeId_1 = require("owa-theme/lib/utils/normalizeThemeId");
var getAvailableThemeIds_1 = require("./getAvailableThemeIds");
function isThemePreviewDirty() {
    var savedTheme = normalizeThemeId_1.default(owa_session_store_1.getUserConfiguration().UserOptions.ThemeStorageId);
    var loadedTheme = getTheme_1.default();
    return (savedTheme !== loadedTheme &&
        // We check against available theme ids, so that the form is not immediately dirty
        // just because you have a theme not available through the form
        getAvailableThemeIds_1.default().indexOf(loadedTheme) !== -1);
}
exports.default = isThemePreviewDirty;
//# sourceMappingURL=isThemePreviewDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/utils/isThemePreviewDirty.js
// module id = 4967
// module chunks = 2